import { useEffect } from 'react';

import { HStack, Text, VStack, Flex } from '@chakra-ui/react';

import style from './JourneyProgress.style';

import { CircularProgress } from '@/components';
import { TProjectCompletionRes } from '@/components/molecules/JourneyProgress/JourneyProgress.types';
import { useGetData } from '@/hooks/useGetData';
import useTranslate from '@/hooks/useTranslate';
import { getProjectCompletionData } from '@/services/users';

interface JourneyProgressProps {
  isHomePage?: boolean;
  isDMTMobile?: boolean;
  isDMTSmallDevice?: boolean;
}

const JourneyProgress = ({
  isHomePage = false,
  isDMTMobile = false,
}: JourneyProgressProps) => {
  const { t } = useTranslate();
  const { fetchData, data, isLoading } = useGetData<TProjectCompletionRes>();

  useEffect(() => {
    fetchData(getProjectCompletionData);
  }, []);

  return (
    <HStack
      sx={
        isHomePage && isDMTMobile
          ? style.homePageDMTMobileRoot
          : isHomePage && !isDMTMobile
            ? style.homePageRoot
            : style.root
      }
    >
      <VStack sx={style.textWrapper}>
        <Flex>
          <Text
            sx={{ ...style.title, color: isDMTMobile ? 'white' : 'black' }}
            whiteSpace="pre-line"
          >
            {t('portal_journey_completion').replace(/ (\S+)$/, '\n$1')}
          </Text>
        </Flex>
      </VStack>
      <VStack>
        <CircularProgress
          isIndeterminate={isLoading}
          value={data?.projectPercentage ?? 0}
          color={isDMTMobile ? 'white' : 'black'}
        />
      </VStack>
    </HStack>
  );
};

export default JourneyProgress;
